export const useBlogPaths = () => {
  const { locale } = useI18n();
  const localePath = useLocalePath();

  const getArticlePath = (article: any) => {
    return localePath(`/` + article.uri);
  };

  const getIndexPath = () => `/${locale.value}/blog`;

  const getAuthorPath = (authorBlog: any) => localePath(`/` + authorBlog.uri);

  const getTermPath = (term: any) => localePath(`/` + (term.uri ));

  return {
    getArticlePath,
    getIndexPath,
    getAuthorPath,
    getTermPath,
  };
};
